/**
 * Fetch location information from coordinates using Nominatim reverse geocoding
 * @param {number} lat - Latitude
 * @param {number} lon - Longitude
 * @returns {Promise<Object>} Location information object
 */
export async function getLocationFromCoordinates(lat, lon) {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&addressdetails=1`,
      {
        headers: {
          'User-Agent': 'SemafixApp/1.0'
        }
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    return {
      fullAddress: data.display_name || 'Unknown location',
      road: data.address?.road || null,
      town: data.address?.town || data.address?.city || null,
      municipality: data.address?.municipality || null,
      county: data.address?.county || null,
      state: data.address?.state || null,
      country: data.address?.country || null,
      // Format a nice display name
      displayName: formatLocationName(data.address)
    };
  } catch (error) {
    console.error('Error fetching location:', error);
    return {
      fullAddress: 'Unknown location',
      displayName: 'Unknown location'
    };
  }
}

/**
 * Format location name from address components
 * @param {Object} address - Address object from Nominatim
 * @returns {string} Formatted location name
 */
function formatLocationName(address) {
  if (!address) return 'Unknown location';
  
  // Priority: Town/City, State
  const town = address.town || address.city || address.municipality;
  const state = address.state;
  
  if (town && state) {
    return `${town}, ${state}`;
  } else if (town) {
    return town;
  } else if (state) {
    return state;
  } else if (address.county) {
    return address.county;
  }
  
  return 'Unknown location';
}
